// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import {hasAccess} from '../../../shared/services/security';

const UsefulLinksPanel = props =>
    <div className='useful-links-panel'>
        <header>
            <FormattedMessage id='Links'/>
        </header>
        <div className='links'>
            <ul className='link-list'>
                <li>
                    <button
                        className='administrator-button side-bar-button'
                        disabled={true}
                    >
                        <FormattedMessage id='Administrator'/>
                    </button>
                </li>
                <li>
                    <button
                        className='mass-update-button side-bar-button'
                        disabled={!hasAccess(props.security, 'RECALLED_PARTS', 'RECALLED_PARTS_MASS_UPDATE')}
                        onClick={props.onMassUpdate}
                    >
                        <FormattedMessage id='RGA Mass Update'/>
                    </button>
                </li>
                <li>
                    <button
                        className='rga-upload-button side-bar-button'
                        disabled={!hasAccess(props.security, 'RECALLED_PARTS', 'RECALLED_PARTS_DATALOAD')}
                        onClick={props.onMassUpload}
                    >
                        <FormattedMessage id='RGA Uploads'/>
                    </button>
                </li>
            </ul>
        </div>
    </div>;

UsefulLinksPanel.displayName = 'UsefulLinksPanel';

UsefulLinksPanel.propTypes = {
    onMassUpdate: PropTypes.func.isRequired,
    onMassUpload: PropTypes.func.isRequired,
    security: PropTypes.instanceOf(Security).isRequired
};

export default UsefulLinksPanel;



// WEBPACK FOOTER //
// ./src/rga/search/components/useful-links-panel.js